import React from 'react'
import { Card, Space, Button, Row, Col, Typography, Tag, theme } from 'antd'
import { UserOutlined, FileTextOutlined } from '@ant-design/icons'
import { formatDate, getStatusBadge, formatDiagnosis } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const { Text } = Typography

const DischargeCard = ({ discharge, onView }) => {
  const { token } = theme.useToken()

  return (
    <Card
      title={
        <Space>
          <UserOutlined />
          <span>{discharge.patientName}</span>
          <Text type='secondary'>({discharge.patientId})</Text>
        </Space>
      }
      extra={
        <Space>
          {getStatusBadge(discharge.status)}
          <Button
            icon={<FileTextOutlined style={{ color: token.colorPrimary }} />}
            size='small'
            onClick={() => onView(discharge)}
            style={{
              background: hexToRGBA(token.colorPrimary, 0.1),
              borderColor: token.colorPrimary,
              color: token.colorPrimary
            }}
          >
            View
          </Button>
        </Space>
      }
      style={{ marginBottom: '16px' }}
    >
      <Row gutter={[16, 8]}>
        <Col span={12}>
          <Text type='secondary'>Department:</Text> {discharge.department}
        </Col>
        <Col span={12}>
          <Text type='secondary'>Attending:</Text> {discharge.attendingPhysician}
        </Col>
        <Col span={12}>
          <Text type='secondary'>Admission:</Text> {formatDate(discharge.admissionDate)}
        </Col>
        <Col span={12}>
          <Text type='secondary'>Discharge:</Text> {formatDate(discharge.dischargeDate)}
        </Col>
        <Col span={24}>
          <Text type='secondary'>Diagnosis:</Text>
          <div style={{ marginTop: '4px' }}>{formatDiagnosis(discharge.diagnosisList)}</div>
        </Col>
      </Row>
    </Card>
  )
}

const DischargeCardList = ({ discharges, onView }) => {
  if (!discharges || discharges.length === 0) {
    return (
      <Card>
        <Text>No pending discharge instructions match your filters.</Text>
      </Card>
    )
  }

  return (
    <div className='pending-discharges'>
      {discharges.map((discharge) => (
        <DischargeCard key={discharge.dischargeId} discharge={discharge} onView={onView} />
      ))}
    </div>
  )
}

export default DischargeCardList
